import { createUseStyles } from 'react-jss';

import styling from '../../../services/styling';
import { variantMapping } from '../../Typography/constants';

export default createUseStyles(
  {
    input: {
      width: '100%',
      boxSizing: 'border-box',
      background: 'none',
      border: 'none',
      padding: [22, 20],
      ...variantMapping.inputValue.styles,
      color: 'inherit',
      appearance: 'none',
      resize: 'none',
      textShadow: 'inherit',
      '&:focus': {
        outline: 'none',
      },
    },
    inputLg: {
      padding: [28, 50],
    },
    inputResize: {
      resize: 'vertical',
      maxHeight: 500,
    },
  },
  { name: 'inputTextarea' },
);
